import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { Drivers } from '@ionic/storage';
import { IonicStorageModule, Storage } from '@ionic/storage-angular';


import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AssessmentsService } from './app/services/rock/Assessments/Assessments.service';
import { RockService } from './app/services/rock/rock.service';
import { PeopleService } from './app/services/rock/People/People.service';
import { AttributeValuesService } from './app/services/rock/AttributeValues/AttributeValues.service';
import { enableProdMode, importProvidersFrom } from '@angular/core';

import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireModule } from '@angular/fire/compat';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { StorageService } from './app/services/storage/storage.service';
import { GroupsService } from './app/services/rock/Groups/Groups.service';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    RockService,
    AssessmentsService,
    PeopleService,
    GroupsService,
    AttributeValuesService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(withInterceptorsFromDi()),
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    StorageService,
    AngularFirestore,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    provideStorage(() => getStorage()),
    importProvidersFrom(AngularFireModule.initializeApp(environment.firebaseConfig),),
    importProvidersFrom(IonicStorageModule.forRoot({
      name: '__spiritual_gifts_test',
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
    })),
  ],
});
